
class CardOfferRuleCell extends MUITableViewCell
{
    
}